import { Route } from "@angular/router";
import { LectureCheckComponent } from "./lecture-check.component";

export const LectureCheckRouting: Route = {
    path: 'check',
    component: LectureCheckComponent,
    data: {
        breadcrumb: "Vérification de la lecture"
    }
};
